export default function (etat) {
    if ("LUCRATIF" === etat) {
        return "But lucratif"
    } else if ("NON_LUCRATIF" === etat) {
        return "But non lucratif"
    }
    return null;
}
